import { render, staticRenderFns } from "./AInsurancePolicy.vue?vue&type=template&id=47ce76cc&scoped=true"
import script from "./AInsurancePolicy.vue?vue&type=script&lang=js"
export * from "./AInsurancePolicy.vue?vue&type=script&lang=js"
import style0 from "./AInsurancePolicy.vue?vue&type=style&index=0&id=47ce76cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce76cc",
  null
  
)

export default component.exports